/**
 * Creates an array with end number of elements.
 * @param end
 * @param startAt
 * @returns
 */
export function range(end: number) {
  return [...Array(end).keys()];
}
